import client from './client'

export const signIn = (email: string, password: string) => {
  return client.post('/users/sign_in', { user: { email: email, password: password } })
}

export const signOut = () => {
  return client.delete('/users/sign_out')
}
